import React, { useEffect, useRef, useState } from "react";
import Logo, { NewLogo } from "../layouts/logo";
import { useNavigate } from "react-router";
// import Notification from "../../assets/icons/notification.svg";
import Messaging from "../../assets/icons/messaging.svg";
import { Icon } from "@iconify/react";
import UserGuide from "../../assets/icons/users-alt.svg";
import FaqIcon from "../../assets/icons/comment-info.svg";
import SupportIcon from "../../assets/icons/chat 01.svg";

const Header = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState(null);
  const [menu, setMenu] = useState(false);
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  const containerRef = useRef<HTMLDivElement>(null);
  const dropdownRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Check if click target is inside the container
      if (!containerRef.current?.contains(event.target as Node)) {
        setActive(null);
      }
    };

    // Only add listener if a dropdown is open
    if (active !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [active]);
  const links = [
    {
      name: "about",
      url: "/about",
      action: () => scrollToSection("about"),
    },
    {
      name: "resources",
      url: "/resources",
      children: [
        {
          action: () =>
            window.open(
              "https://stakeholder-map.nyc3.digitaloceanspaces.com/WSH%20Tools%20Mapping%20Dashboard%20User%20Guide%20(2).pdf",
              "_blank"
            ),
          icon: UserGuide,
          text: "User Guide",
        },
      ],
    },
    {
      name: "help",
      url: "/help",
      children: [
        {
          action: () => {
            setActive(null);
            scrollToSection("faq");
          },
          icon: FaqIcon,
          text: "Faq",
        },
        {
          action: () => {
            setActive(null);
            scrollToSection("help");
          },
          icon: SupportIcon,
          text: "Support",
        },
      ],
    },
  ];
  return (
    <div>
      <div className="relative w-full h-20 bg-transparent lg:h-28">
        {active !== null && (
          <div
            className="fixed top-0 left-0 w-full h-full bg-black opacity-30 z-[999]"
            onClick={() => setActive(null)}
          />
        )}
        <div
          ref={containerRef}
          className="flex items-center justify-between h-full section-container"
        >
          <div>
            <Logo />
          </div>
          <div>
            <Icon
              icon={"material-symbols:menu"}
              color="white"
              className="block lg:hidden"
              style={{
                fontSize: "40px",
              }}
              onClick={() => setMenu(true)}
            />
          </div>
          <div className="items-center hidden h-full gap-10 text-base font-medium text-white capitalize lg:flex inter">
            {links?.map((l, i) => (
              <div
                ref={(el) => (dropdownRefs.current[i] = el)}
                className="relative"
              >
                <h6
                  onClick={() => {
                    if (l?.action) {
                      l.action();
                    } else {
                      setActive(i);
                    }
                  }}
                  key={i}
                  className="cursor-pointer"
                >
                  {l?.name}
                </h6>
                {active === i && (
                  <div
                    style={{
                      boxShadow: "0px 10px 10px -5px #0000000A",
                    }}
                    className="absolute z-[1000] top-8 p-4 right-0 w-48 bg-white rounded-lg"
                  >
                    <div className="divide-y">
                      {l?.children?.map((chi) => (
                        <div
                          onClick={chi?.action}
                          className="flex items-center h-12 gap-3"
                        >
                          <img src={chi?.icon} alt="" className="" />
                          <h5 className="text-sm font-medium capitalize text-da-blue-500">
                            {chi?.text}
                          </h5>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
            <button
              onClick={() => navigate("/dashboard")}
              style={{
                border: "2px solid #FFFFFF",
              }}
              className="w-40 h-12 text-base font-medium text-white bg-transparent rounded-xl inter"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
      {menu && (
        <div className="absolute top-0 w-full p-6 bg-white">
          <div className="flex justify-end">
            <Icon
              icon={"mingcute:close-fill"}
              color="#002A54"
              className="block lg:hidden"
              style={{
                fontSize: "24px",
              }}
              onClick={() => setMenu(false)}
            />
          </div>
          <div className="mt-5 space-y-4">
            {links?.map((link) => (
              <h6
                onClick={() => scrollToSection(link?.name)}
                className="text-xl font-medium capitalize cursor-pointer text-da-blue-600"
              >
                {link?.name}
              </h6>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export const PageHeader = () => {
  const [showGuideMenu, setShowGuideMenu] = useState(false);

  return (
		<div className="w-full bg-[#142239] h-20 flex justify-between items-center">
			<div className="w-[25%] h-full flex items-center pl-6 border-r border-r-[#C4C4C4]">
				<NewLogo />
			</div>
			<div className="flex items-center gap-5 pr-6">
				<div className="relative">
					<button
						onClick={() => setShowGuideMenu(!showGuideMenu)}
						className="flex items-center gap-2 text-white hover:text-gray-200">
						<Icon icon="mdi:book-open-page-variant" className="text-xl" />
						<span>User Guide</span>
					</button>
					{showGuideMenu && (
						<div className="absolute right-0 z-50 w-48 mt-2 bg-white rounded-lg shadow-lg">
							<a
								href="/assets/Tools Mapping User Guide.pdf"
								download="WSH Tools Mapping User Guide.pdf"
								type="application/pdf"
								className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
								onClick={() => setShowGuideMenu(false)}>
								Download User Guide
							</a>
						</div>
					)}
				</div>
				{/* <img src={Notification} alt="" className="" /> */}
				<a href="mailto:team@wshdatalabs.com">
					{" "}
					<img src={Messaging} alt="" className="" />
				</a>
			</div>
		</div>
	);
};

export default Header;
